import { centsToDollarString } from './constants';

export const TIME_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'approved', label: 'Approved' },
  { value: 'voided', label: 'Voided' },
];

export const TIME_STATUS_STYLES = {
  draft: 'bg-gray-800 text-gray-300 border-gray-700',
  approved: 'bg-green-900/40 text-green-400 border-green-800',
  voided: 'bg-red-900/40 text-red-400 border-red-800',
};

export const timeStatusLabel = (v) =>
  (TIME_STATUS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const PAY_METHOD_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'check', label: 'Check' },
  { value: 'ach', label: 'ACH / Bank Transfer' },
  { value: 'other', label: 'Other' },
];

export const payMethodLabel = (v) =>
  (PAY_METHOD_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const fmtMinutes = (m) => {
  if (m == null) return '—';
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h === 0) return `${mm}m`;
  return mm === 0 ? `${h}h` : `${h}h ${mm}m`;
};

export const payDisplay = (cents) =>
  cents == null ? 'Not calculated' : centsToDollarString(cents);

export const costDisplay = (cents) =>
  cents == null ? 'Rate not set' : centsToDollarString(cents);
